module.exports = __webpack_public_path__ + "img/w3_trash_solid_recover_light.93d4723e.png";